import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
function RemarkViewModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.ConfigurationItem = parent;
    self.Refresh = function () {
        var def = $.Deferred();
        def.resolve();
        return def.promise();
    };
}
;
Bao.inherit(RemarkViewModel, ChildTabViewModel);
RemarkViewModel.prototype.CompleteCheck = function () {
    return true;
};
export default RemarkViewModel;